import React from 'react';

import RadioButton from './RadioButton/RadioButton';

import classes from './RadioGroup.module.css';


// Props List :-
// radioButtons = the list of radio button to be populated
// clicked = the function that handles radio button click
// inputIdentifier = the inputIdentifier in the form fields for the radio group
// styleclass = list of style classes as follows :-
// Horizontal = for horizontal  alignment of radio buttons
// Vertical = for vertical alignment of radio buttons

const radioGroup = (props) => {
    //Log(props);
    let styleClasses = [classes.RadioGroup];

    if (props.styleclass !== undefined) {
        const styles = props.styleclass.split(' ');
        for (let style in styles) {
            styleClasses.push(classes[styles[style].trim()]);
        }
    }

    const radioButtons = props.radioButtons.map((item, pos) => {
        return(
            <div key={pos} className={classes.RadioItem}>
                <RadioButton
                    active={item.active}
                    label={item.label}
                    clicked={() => props.clicked(pos, props.inputIdentifier)}
                />
            </div>
        );
    })

    return(
        <div className={styleClasses.join(' ')}>
            {radioButtons}
        </div>
    );
}

export default radioGroup;